import React, { useState, useEffect } from 'react';
import { Popover, Typography, Divider, List, ListItem } from '@mui/material';
import { Checkbox, Button } from '../';
import type { TagsListProps } from './types';

export const TagsList: React.FC<TagsListProps> = (props: TagsListProps) => {
  const {
    id,
    open,
    anchorEl,
    listTitle,
    tags,
    buttonText,
    onTagSelect,
    onClose,
    onCreateTag,
  } = props;

  const [tagList, setTagList] = useState(tags);

  const handleSelectTag = (tag: any) => (): void => {
    onTagSelect(tag);
    setTagList(
      tagList.map((t: any) =>
        t.name === tag.name ? { ...t, selected: !(t.selected as boolean) } : t,
      ),
    );
  };

  useEffect(() => {
    setTagList(tags);
  }, [tags]);

  return (
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Typography sx={{ p: 2 }} align="center">
          {listTitle}
        </Typography>
        <Divider />
        <List>
          {tagList.map((tag, index) => (
            <ListItem key={index} dense onClick={handleSelectTag(tag)}>
              <Checkbox
                label={tag.name}
                checked={tag.selected}
                tabIndex={-1}
                value={tag.selected}
              />
            </ListItem>
          ))}
        </List>
        <Button onClick={onCreateTag} variant="contained">
          {buttonText}
        </Button>
      </Popover>
    </>
  );
};
